import React from "react";
import BaseDetails, { DetailRow } from "./baseDetails";

export default function modelDataDeleteDetails({ row }) {
    // Show deleted name only if not already shown in base details
    const showDeletedName = !row.model_data_name && row.name;

    return (
        <BaseDetails row={row}>
            {showDeletedName ? (
                <DetailRow label="Deleted">
                    <span className="font-medium text-red-600">{row.name}</span>
                </DetailRow>
            ) : null}
        </BaseDetails>
    );
}
